import React, { useState, useEffect } from 'react';
import { Table, Col, Row, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

export const QuickPreview = ({ history }) => {

    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    const [date, setDate] = useState(null);
    const [terminal, setTerminal] = useState(null);

    useEffect(() => {
        // Listen for the custom event and update the date state
        const handleDateSelected = (event) => {
            setDate(event.detail.date);
            setTerminal(event.detail.terminal);
            setModal(true); // Show modal when date is picked
        };

        document.addEventListener('dateSelected', handleDateSelected);

        // Cleanup event listener on component unmount
        return () => {
            document.removeEventListener('dateSelected', handleDateSelected);
        };
    }, []);

    const BusesTable = () => {
        if (!history[date]) {
            return <tr><td colSpan="7">No data available</td></tr>;
        }

        return (
            <Table className='sm' sm hover borderless striped>
                <thead>
                    <tr>
                        <th>Bus</th>
                        <th>Terminal</th>
                        <th>Skids</th>
                        <th>Weight</th>
                        <th>Length</th>
                        <th>Height</th>
                        <th>Orders</th>
                    </tr>
                </thead>
                <tbody>
                    {history[date].map((bus, index) => (
                        (terminal === "all" || terminal === bus.terminal) ? (
                            <tr key={index}>
                                <td>{bus.bus}</td>
                                <td>{bus.terminal}</td>
                                <td>{bus.skids}</td>
                                <td>{`${bus.weight} (${bus.p_weight}%)`}</td>
                                <td>{`${bus.total_length} (${bus.p_length}%)`}</td>
                                <td>{bus.height}</td>
                                <td>
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>Order</th>
                                                <th>Customer</th>
                                                <th>Weight</th>
                                                <th>Skids</th>
                                                <th>Partials</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {bus.orders.map((order, index) => (
                                                <tr className="border sm" key={order.order_no}>
                                                    <td>{order.order_no}-{order.order_group}</td>
                                                    <td>{order.customer}</td>
                                                    <td>{order.weight}</td>
                                                    <td>
                                                        {order.units}
                                                        {order.partial_count > 0 ? ` (${order.partial_skids})` : <></>}
                                                    </td>
                                                    <td>{order.partial_count}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </td>
                            </tr>
                        ) : null
                    ))}
                </tbody>
            </Table>
        );
    };

    return (
        <Modal
            style={{ transform: 'translateY(0%)' }}
            isOpen={modal}
            toggle={toggle}
        >
            <ModalHeader className='bg-dark text-white text-center p-3' toggle={toggle}>
                <strong>Buses Picked Up {date}</strong>
            </ModalHeader>
            <ModalBody className="m-0 mt-1 text-center p-1">
                <Row>
                    <Col>
                        <div>
                            <BusesTable />
                        </div>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button className='btn bg-danger text-white' onClick={toggle}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};
